import { render, staticRenderFns } from "./export-abacus-company.vue?vue&type=template&id=38523ece&"
import script from "./export-abacus-company.vue?vue&type=script&lang=js&"
export * from "./export-abacus-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports